var _defs, _title, _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPaymentRequest = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 56 15",
  style: {
    verticalAlign: "middle"
  }
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4285f4;}.cls-2{fill:#34a853;}.cls-3{fill:#fbbc04;}.cls-4{fill:#ea4335;}.cls-5{fill:#f3f3f3;}.cls-6{fill:#f35325;}.cls-7{fill:#81bc06;}.cls-8{fill:#05a6f0;}.cls-9{fill:#ffba08;}"))), _title || (_title = /*#__PURE__*/React.createElement("title", null, "mobile Payment logos")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.64,4.28A1.92,1.92,0,0,1,7.11,5a2.14,2.14,0,0,1,.54-1.58,2.28,2.28,0,0,1,1.52-.78,2.34,2.34,0,0,1-.53,1.64m.52.84c-.84,0-1.56.48-2,.48s-1-.46-1.69-.45A2.53,2.53,0,0,0,3.39,6.44C2.48,8,3.16,10.32,4,11.6c.43.63.94,1.32,1.62,1.3s.9-.42,1.68-.42,1,.42,1.68.4,1.15-.63,1.58-1.26a5.29,5.29,0,0,0,.7-1.45A2.3,2.3,0,0,1,9.93,8.09,2.33,2.33,0,0,1,11,6.14a2.37,2.37,0,0,0-1.88-1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M32,7.88a6.63,6.63,0,0,0-.08-1H27.31V8.77H30a2.29,2.29,0,0,1-1,1.48v1.22h1.58A4.77,4.77,0,0,0,32,7.88Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M27.31,12.65a4.66,4.66,0,0,0,3.24-1.18L29,10.25A3,3,0,0,1,24.56,8.7H22.94V10A4.89,4.89,0,0,0,27.31,12.65Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M24.56,8.7a3,3,0,0,1,0-1.87V5.57H22.94a4.85,4.85,0,0,0,0,4.39Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M27.31,4.81a2.66,2.66,0,0,1,1.87.74h0l1.4-1.4a4.69,4.69,0,0,0-3.27-1.27,4.89,4.89,0,0,0-4.37,2.69l1.62,1.26A2.93,2.93,0,0,1,27.31,4.81Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 43.32,
  y: 2.72,
  width: 10.08,
  height: 10.08
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 43.71,
  y: 3.11,
  width: 4.46,
  height: 4.46
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 48.56,
  y: 3.11,
  width: 4.46,
  height: 4.46
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 43.71,
  y: 7.96,
  width: 4.46,
  height: 4.46
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-9",
  x: 48.56,
  y: 7.96,
  width: 4.46,
  height: 4.46
})));
export default SvgPaymentRequest;